export default __webpack_public_path__ + "static/media/DiplomaticoClosed.a7c3a0c5.jpg";